<style src="./FieldAnchor.scss" lang="scss"></style>
<template>
  <section class="mirror-field field-anchor">
    <fieldset>
      <label>
        <input
          type="text"
          v-model="fieldData" />

        <span class="title">
          {{ title }}
        </span>
      </label>
    </fieldset>
  </section>
</template>

<script>
export default {
  name: 'FieldAnchor',
  props: {
    title: '',
    value: ''
  },
  data () {
    return {
      fieldData: ''
    }
  },
  watch: {
    fieldData (v) {
      this.$emit('input', v)
    }
  },
  mounted () {
    this.fieldData = this.value
  }
}
</script>


// WEBPACK FOOTER //
// src/components/bid-mirror/mirror-form/components/field-anchor/FieldAnchor.vue